import { render, staticRenderFns } from "./messageDetails.vue?vue&type=template&id=e8878950&scoped=true"
import script from "./messageDetails.vue?vue&type=script&lang=js"
export * from "./messageDetails.vue?vue&type=script&lang=js"
import style0 from "./messageDetails.vue?vue&type=style&index=0&id=e8878950&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8878950",
  null
  
)

export default component.exports